import * as React from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Button, Icon } from '@openedx/paragon';
import { ArrowDropDown, ArrowDropUp, ChevronRight } from '@openedx/paragon/icons';
import messages from '../../messages';
import { ICON_MAP } from '../../constants';
export function CourseContentList(_ref) {
  let {
    title,
    blocks,
    activateDashboard
  } = _ref;
  const intl = useIntl();
  // using undefined is useful for slicing the list
  const [showCount, setShowCount] = React.useState(5);
  if (!blocks.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column rounded-bottom py-4 px-3 bg-white border-top border-light"
  }, !!title && /*#__PURE__*/React.createElement("h4", {
    className: "h4 mb-4"
  }, title), blocks?.slice(0, showCount).map(block => /*#__PURE__*/React.createElement(Button, {
    key: block.id,
    className: "d-flex flex-row justify-content-start flex-grow-1 mb-2 py-1 px-0",
    variant: "inline",
    onClick: () => activateDashboard(block)
  }, /*#__PURE__*/React.createElement("h5", {
    className: "h5 flex-grow-1 text-left d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(Icon, {
    src: ICON_MAP[block.type],
    size: "xs",
    className: "mr-2 text-gray",
    "aria-hidden": true
  }), /*#__PURE__*/React.createElement("span", null, block.displayName)), /*#__PURE__*/React.createElement(Icon, {
    src: ChevronRight,
    "aria-hidden": true
  }))), blocks?.length > 5 && /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    size: "sm",
    iconAfter: showCount === 5 ? ArrowDropDown : ArrowDropUp,
    onClick: () => setShowCount(showCount === 5 ? undefined : 5)
  }, showCount === 5 ? intl.formatMessage(messages.showMore) : intl.formatMessage(messages.showLess)));
}